const keys = {
  userAuthorizations: 'user:Authorizations',
  currentSiteId: 'site:CurrentSiteId',
} as const;

export default keys;
